import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useStarTheme() {
  const route = useRoute()
  const isLight = computed(() => route.query.theme === 'light')

  // 常用色值
  const colors = computed(() => ({
    bg: isLight.value ? '#ffffff' : '#070707',
    bgCard: isLight.value ? '#f0f2f5' : '#181818',
    bgCardSub: isLight.value ? '#e8edf5' : '#1f1f1f',
    bgPanel: isLight.value ? '#ffffff' : '#181818',
    bgTabActive: isLight.value ? '#ffffff' : '#3d3d3d',
    bgTabBar: isLight.value ? '#f0f0f0' : '#1f1f1f',
    bgActionBtn: isLight.value ? '#f0f2f5' : 'rgba(255,255,255,0.07)',
    bgActionBtnHover: isLight.value ? '#e4e8ef' : 'rgba(255,255,255,0.12)',
    bgInput: isLight.value ? '#f5f5f5' : '#2f2e2e',
    textPrimary: isLight.value ? '#1a1a1a' : '#ffffff',
    textSecondary: isLight.value ? '#666666' : 'rgba(255,255,255,0.6)',
    textMuted: isLight.value ? '#999999' : '#7d7d7d',
    textInput: isLight.value ? '#666666' : '#ffffff',
    textTabActive: isLight.value ? '#fe4043' : '#ffffff',
    divider: isLight.value ? '#f0f0f0' : 'rgba(255,255,255,0.08)',
    statDivider: isLight.value ? '#e0e0e0' : 'rgba(255,255,255,0.12)',
    border: isLight.value ? '#e0e0e0' : 'rgba(255,255,255,0.08)',
    borderInput: isLight.value ? '#d9dbdd' : '#3d3d3d',
    accent: '#fe4043',
    rise: '#fe4043',
    fall: '#39e365',
  }))

  const isDark = computed(() => !isLight.value)

  return { isLight, isDark, colors }
}

/**
 * star 模块路由跳转，自动透传 token / softNameAbbr / reffer / theme
 */
export function useStarRouter() {
  const router = useRouter()
  const route = useRoute()

  const inheritQuery = () => {
    const { token, softNameAbbr, reffer, theme, userType } = route.query
    const q: Record<string, string> = {}
    if (token) q.token = token as string
    if (softNameAbbr) q.softNameAbbr = softNameAbbr as string
    if (reffer) q.reffer = reffer as string
    if (theme) q.theme = theme as string
    // 兼容三种拼写，统一输出为 username
    const username = (route.query.userName || route.query.username || route.query.usename) as string
    if (username) q.username = username
    if (userType) q.userType = userType as string
    return q
  }

  const starPush = (path: string, extraQuery: Record<string, string> = {}) => {
    router.push({ path, query: { ...inheritQuery(), ...extraQuery } })
  }

  return { starPush }
}
